import { motion } from "framer-motion";
import { Dices, Hash } from "lucide-react";

const FiveDCard = ({ result, index }) => (
  <motion.section
    data-testid={`fived-card-${result.provider}`}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35, delay: index * 0.06 }}
    className="flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
  >
    <div className="flex items-center justify-between bg-indigo-700 px-4 py-3.5">
      <div className="flex items-center gap-2.5">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-black/10">
          <Hash className="h-5 w-5 text-white" />
        </span>
        <div>
          <h2 className="font-display text-lg font-extrabold leading-none text-white">{result.providerName}</h2>
          <span className="text-[11px] font-medium text-white/60">5D Result</span>
        </div>
      </div>
      <p className="font-display text-xs font-bold text-white">{result.date || "—"}</p>
    </div>
    <div className="flex flex-1 flex-col divide-y divide-slate-100 p-4">
      {result.prizes.map((p) => (
        <div key={p.label} className="flex items-center justify-between py-2.5">
          <span className="text-xs font-semibold uppercase tracking-widest text-slate-400">{p.label}</span>
          <span className={`font-display tabular font-black tracking-tight ${p.label === "1st" ? "text-3xl text-indigo-700" : "text-2xl text-slate-800"}`}>
            {p.value || "----"}
          </span>
        </div>
      ))}
    </div>
  </motion.section>
);

const SixDCard = ({ result, index }) => (
  <motion.section
    data-testid={`sixd-card-${result.provider}`}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35, delay: index * 0.06 }}
    className="flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
  >
    <div className="flex items-center justify-between bg-fuchsia-700 px-4 py-3.5">
      <div className="flex items-center gap-2.5">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-black/10">
          <Dices className="h-5 w-5 text-white" />
        </span>
        <div>
          <h2 className="font-display text-lg font-extrabold leading-none text-white">{result.providerName}</h2>
          <span className="text-[11px] font-medium text-white/60">6D Result</span>
        </div>
      </div>
      <div className="text-right text-white/60">
        <p className="font-display text-xs font-bold text-white">{result.date || "—"}</p>
        {result.drawId ? <p className="text-[10px]">#{result.drawId}</p> : null}
      </div>
    </div>
    <div className="flex flex-1 flex-col gap-3 p-4">
      <div className="flex flex-col items-center rounded-xl bg-slate-50 py-4">
        <span className="mb-1 text-[11px] font-semibold uppercase tracking-widest text-slate-400">1st Prize</span>
        <span className="font-display tabular text-4xl font-black tracking-tighter text-fuchsia-700">{result.first || "------"}</span>
      </div>
      {result.rows.map((row) => (
        <div key={row.label} className="flex items-center justify-between rounded-lg border border-slate-100 px-3 py-2">
          <span className="text-xs font-semibold uppercase tracking-widest text-slate-400">{row.label}</span>
          <div className="flex gap-2">
            {row.values.map((v, j) => (
              <span key={`${row.label}-${j}`} className="font-display tabular rounded-md bg-slate-100 px-2 py-1 text-base font-bold text-slate-800">
                {v || "----"}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  </motion.section>
);

export { FiveDCard, SixDCard };
